import { post } from './ajax'
import store from '@/store'

let checkCepingPromise
let checkCepingPromiseTimer
const checkCepingTimeout = 2000

/** 检查测评结果 */
export async function checkCeping() {
  // 返回缓存的 checkCepingPromise，以免短时间内多次调用
  if (checkCepingPromise != null) {
    return checkCepingPromise
  }

  checkCepingPromise = post('/studysys/ceping/checkCeping').catch(ex => {
    // 若发生错误，则立即清除 checkCepingPromise
    checkCepingPromise = null
    clearTimeout(checkCepingPromiseTimer)
    throw ex
  })

  // 设置一个定时器，一定毫秒内，清除 checkCepingPromise，以便清除缓存
  clearTimeout(checkCepingPromiseTimer)
  checkCepingPromiseTimer = setTimeout(() => {
    checkCepingPromise = null
  }, checkCepingTimeout)

  return checkCepingPromise
}

/** 同步 isCeping 值到 store 内，并返回 isCeping 的值 */
export async function syncCeping() {
  const data = await checkCeping()
  const isCeping = data.is_ceping == 1
  store.commit('setValue', { isCeping })
  return { data, isCeping }
}



// WEBPACK FOOTER //
// ./src/util/ceping.js